if (!customElements.get('quick-shop')) {
  class Quickshop extends HTMLElement {
    constructor() {
      super();

      this.parentCard = this.closest('[data-product-card]');

      // Bind popup toggle events
      this.parentCard.querySelectorAll('[data-quickshop-toggle]').forEach((button) =>
        button.addEventListener('click', this.onPopupToggle.bind(this))
      );

      // Bind option select events
      this.querySelectorAll('[data-quickshop-option]').forEach((option) => {
        option.addEventListener('click', this.onOptionSelect.bind(this, option.value, option.dataset.inventoryQuantity));
      });
    }

    /**
     * Toggles the options popup
     * @description Renders the products based on the fetch url data.
     */
    onPopupToggle() {
      const popup = this.querySelector('[data-quickshop-popup]');
      const popupIsOpenClass = 'quickshop__popup--is-open';

      popup.classList.toggle(popupIsOpenClass);
    }

    /**
     * Adds a variant to the cart
     * @description Adds the clicked option/variant to the cart leveraging the product form component.
     * @param {String} variantId
     * @param {String} inventoryQuantity
     */
    onOptionSelect(variantId, inventoryQuantity) {
      const productForm = this.querySelector('product-form');
      const hiddenId = productForm.querySelector('input[name="id"]');
      const hiddenInventoryQty = productForm.querySelector('input[name="inventory_quantity"]');
      const submitButton = productForm.querySelector('[type="submit"]');

      hiddenId.value = variantId;
      hiddenInventoryQty.value = inventoryQuantity;
      submitButton.click();
    }
  }

  window.Quickshop = Quickshop;
  customElements.define('quick-shop', Quickshop);
}

